var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22222 16.6667H22.7778V14.4444H7.22222V16.6667ZM5 21.1111H20.5556V18.8889H5V21.1111ZM9.44444 10V12.2222H25V10H9.44444Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/OverviewIcon.87ca16d3.svg";
export { ForwardRef as ReactComponent };